<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div>
      <div id="track">
        <div class="d-flex justify-content-between">
          <div>
            <a href="/ExhibitorServiceTW/">展覽列表</a><span>/</span> <em name="Exhibition"></em><span>/</span
            ><span @click.prevent="toProMain" class="pointer px-0" style="color: #1a73e8">參展產品</span
            ><span>/</span>歷屆參展列表
          </div>
          <div>
            <span class="bold">登入帳號 :</span>
            <span> {{ UserId }}</span>
          </div>
        </div>
      </div>
      <!-- track end -->
      <!-- article -->
      <article>
        <div class="MbDevice">
          <div class="homeLeft">
            <div class="UserAccount ml-1">
              <span class="bold">登入帳號 :</span>
              <span> {{ UserId }}</span>
            </div>
            <hr />
            <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
            <div class="expoInfo">
              <p class="bold" name="Exhibition"></p>
              <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
              <p>{{ ExhVenue }}</p>
            </div>
            <p class="clear"></p>
          </div>
        </div>

        <div class="contentBox">
          <div id="SliderTop">
            <i class="fas fa-2x fa-chevron-up toTop-arrow"></i>
          </div>
          <h1>歷屆參展列表</h1>
          <p class="my-3">&nbsp;</p>
          <p class="alert">列表顯示您兩年內所參加的展覽，請先選擇您要複製產品的展覽。</p>
          <p class="my-3">&nbsp;</p>

          <ul v-for="item in ExhibitionList" class="mx-5 my-3">
            <li>
              <div class="row justify-content-between align-items-center">
                <div class="col-md-10 text-md-left text-center">
                  <div class="lineStyle align-items-center">
                    <div class="mr-md-5">
                      <img
                        :src="`//www.ccie.com.tw/exhibition/images/exlogo/${item.ExhLogo}`"
                        class="img-fluid imgSize"
                      />
                    </div>
                    <div>
                      <div class="d-flex justify-content-md-start justify-content-center">
                        <div>
                          <span class="bold" style="font-size: 18px">{{ item.Exhibition }}</span>
                        </div>
                        <div class="PcDevice" style="word-break: break-all; width: 160px">
                          <span class="ml-2 ProNumStyle">{{ item.productNumber }}個產品</span>
                        </div>
                      </div>

                      <span>
                        <div class="MbDevice my-1">
                          <span class="ProNumStyle">{{ item.productNumber }}個產品</span>
                        </div>

                        <p class="gray">{{ item.ExhBegin }} ~ {{ item.ExhEnd }}</p>
                        <p class="gray">{{ item.ExhVenue }}</p>
                        <p class="divider">&nbsp;</p>
                        <p>
                          <span class="colorBG">{{ item.AppNo }}</span>
                          {{ item.Directory_ComName }}
                        </p>
                        <p>展覽分區 : {{ item.ExhibArea }}</p>
                        <p>
                          攤位號碼 :
                          <span v-if="item.BoothNo == 'N/A'"> - </span>
                          <span v-else> {{ item.BoothNo }} </span>
                        </p>
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-md-2 text-right PcDevice">
                  <div class="btn btn-lg btn-primary" @click.prevent="toAppliedPro(item.RegNo)">選擇</div>
                </div>
                <div class="col-md-2 mb-2 text-center MbDevice">
                  <div class="btn btn-primary" @click.prevent="toAppliedPro(item.RegNo)">選擇</div>
                </div>
              </div>
              <hr />
            </li>
          </ul>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import axios from 'axios'

  export default {
    metaInfo() {
      return {
        title: '歷屆參展列表 - 展昭參展商管理系統',
      }
    },

    data() {
      return {
        UserId: '',
        RegNo: '',
        lang: 'tw',
        ExhibitionList: [],

        messages: [
          {
            message: '訊息內容',
            status: 'warning',
            timestamp: 123,
          },
        ],

        ExhLogo: '',
        ExhBegin: '',
        ExhEnd: '',
        ExhVenue: '',
        eExhVenue: '',
      }
    },
    methods: {
      toAppliedPro(id) {
        const vm = this
        if (vm.lang == 'tw') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/productHistoryPro?no=${vm.RegNo}&ProRegNo=${id}`
        } else {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/productHistoryPro?no=${vm.RegNo}&ProRegNo=${id}`
        }
      },

      toProMain() {
        const vm = this
        if (vm.lang == 'tw') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/product?no=${vm.RegNo}`
        } else {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/product?no=${vm.RegNo}`
        }
      },
    },

    created() {
      const vm = this

      $(() => {
        $('#SliderTop').click(() => {
          $('html,body').animate({ scrollTop: 0 }, 'slow')
          return false
        })

        $(window)
          .scroll(function () {
            if ($(this).scrollTop() > 300) {
              $('#SliderTop').fadeIn(222)
            } else {
              $('#SliderTop').stop().fadeOut(222)
            }
          })
          .scroll()
      })

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/UserID`).then((response) => {
        vm.UserId = response.data
      })

      //url取出展碼
      let currentUrl = location.href

      //取得RegNo
      vm.RegNo = currentUrl.split('no=')[1].split('&')[0]

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`).then((response) => {
        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.ExhLogo}`
        vm.ExhBegin = response.data.Data.ExhBegin
        vm.ExhEnd = response.data.Data.ExhEnd
        vm.ExhVenue = response.data.Data.ExhVenue
        vm.eExhVenue = response.data.Data.eExhVenue
      })

      //歷年報名展覽紀錄

      let url2 = `https://www.chanchao.com.tw/apiExhibitors/Product/PreviousRegister?RegNo=${vm.RegNo}&lang=${vm.lang}`

      axios.get(url2).then(function (response) {
        // console.log(response.data.Data)
        vm.ExhibitionList = response.data.Data
      })
    },
  }
</script>

<style lang="scss">
  .card-footer {
    padding: 0.5rem 0.2rem;
    background-color: rgb(255 255 255 / 3%);
    border-top: 1px solid rgba(0, 0, 0, 0.125);
  }

  .colorBG {
    background-color: #eee;
    display: inline;
    padding: 2px 5px;
  }

  .imgSize {
    width: 180px;
  }

  .lineStyle {
    display: flex;
  }

  @media (max-width: 501px) {
    .lineStyle {
      display: block;
      margin-bottom: 25px;
    }

    .imgSize {
      width: 100px;
      margin-bottom: 15px;
    }
  }

  .ProNumStyle {
    background-color: #ffefd1;
    padding: 2px 5px;
    font-size: 16px;
  }
</style>
